import React, { Component } from 'react';
import { Growl } from 'primereact/growl';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Captcha } from 'primereact/captcha';

import servicioHttp from '../servicios/ServicioHttp';
import servicioObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import { obtenerInformacionNavegador } from '../servicios/ServicioInformacionNavegador';

export class RecuperarContrasena extends Component {
    constructor() {
        super();
        this.state = {
            usuario: {},
            errores: {},
            mostralModal: false,
            verificaCapchap: false
        };
    }

    recuperarContrasena = () => {
        let { usuario, tokenCaptcha } = this.state;
        let validacion = this.validarForm(usuario);
        this.setState({ errores: validacion });
        let agente=obtenerInformacionNavegador();
        if (servicioObjetos.esObjetoVacio(validacion)) {
            usuario.token = tokenCaptcha;
            usuario.navegador=agente.client.name +" "+agente.client.version;
            usuario.so=agente.os.name +" " +agente.os.version + " "+agente.os.platform +" "+ agente.device.type +" "+agente.device.brand+ " "+agente.device.model;
            servicioHttp
                .consumirPostHttp("/usuario/recuperar_contrasena.json", usuario)
                .then((response) => {
                    this.growl.show({ severity: response.data.error === false ? "success" : "error", summary: "", detail: response.data.mensaje, life: 10000 });
                    if (response.data.error) {
                        this.expireCaptcha();
                    } else {
                        this.resetEstados();
                    }
                }).catch((e) => {

                });
        }
    };

    validarForm = (valor) => {
        const errores = {};
        const email = /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i;
        if (!valor.usuario) {
            errores.usuario = "el campo es requerido";
        } else {
            if (email.test(valor.usuario)) {
            } else {
                errores.usuario = "el correo no es valido";
            }
        }

        let { tokenCaptcha } = this.state;
        if (servicioObjetos.esObjetoVacio(tokenCaptcha))
            errores.captcha = 'Debe de resolver el captcha';
        return errores;
    };

    mostrarModal = () => {
        this.setState({ mostralModal: true, usuario: {}, errores: {} });
    };

    resetEstados = () => {
        this.setState({ mostralModal: false });
    }

    asignarDatos = (event, mayusculas) => {
        servicioObjetos.asignarAtributosObjeto(event, this, mayusculas);
    }

    respuestaCaptcha = (response) => {
        this.setState({
            tokenCaptcha: response.response
        });
    }

    expireCaptcha = () => {
        this.setState({ tokenCaptcha: null });
        this.captcha.reset();
    }

    render() {

        const pieDialogo = (
            <div className="ui-dialog-buttonpane p-clearfix">
                <Button label="Guardar" icon="pi-md-check" onClick={this.recuperarContrasena} />
                <Button label="Cancelar" icon="pi-md-close" onClick={this.resetEstados} className="p-button-danger " />
            </div>
        );

        let { errores, usuario, mostralModal } = this.state;          
        return (
            <div>                
                <Growl ref={(el) => this.growl = el} />
                <span className="cursor" onClick={this.mostrarModal}><strong style={{ color: '#4f9cd2' }}>Recuperar Contraseña Aquí</strong></span>                
                <Dialog appendTo={document.body} visible={mostralModal} header="Recuperar mi contraseña" modal={true} footer={pieDialogo} onHide={this.resetEstados} >
                    <div className="p-col-12">                    
                        <div className="card card-w-title">
                            <div className="p-grid form-group">
                                <div className="p-col-12 p-md-12"></div>
                                <div className="p-col-12 p-md-12">
                                    <span className="md-inputfield">
                                        <InputText style={{ width: '100%' }} id="usuario.usuario" name="usuario.usuario" className={errores.usuario ? "p-error" : ""} value={usuario.usuario || ""} onChange={this.asignarDatos} autoFocus="true" />
                                        <label>Por favor ingresa el correo electrónico</label>
                                        {errores.usuario ? (
                                            <div>
                                                <br /> <Message severity="error" text={errores.usuario} />{" "}
                                            </div>
                                        ) : null}
                                    </span>
                                </div>
                                <div className={errores.captcha ? 'p-col-12 p-md-12 p-error' : 'p-col-12 p-md-10'}>
                                    <Captcha ref={(r) => this.captcha = r} siteKey="6Lc5NNIZAAAAAE516_ffb7LZRGAsD6WysJ0YJhOQ" onResponse={this.respuestaCaptcha} onExpire={this.expireCaptcha} language="es"></Captcha>
                                    {errores.captcha ? <div><Message severity="error" text={errores.captcha} /> </div> : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}